import * as consentTypes from './consentTypes';
import { fetchConsentsByDefKey, saveConsentAcceptances, downloadSummary } from '../../../../services/consent.service';
import { CONSENT_TYPES } from '../../../../constants/constants';
import { saveAPIFile } from 'src/helpers';
import { getDashboardURL } from 'src/helpers/commonFunctions';

export const initPagesData = _pages => {
  return dispatch => {
    let pageIdx = 0;
    let pages = _pages.map(p => {
      return { id: p, accepted: false, read: false };
    });

    dispatch({
      type: consentTypes.INIT_CONSENT_LIST,
      pages,
      pageIdx,
      pageCount: _pages.length,
    });
  };
};

export const setCurrentPage = pageIdx => {
  return dispatch => {
    dispatch({
      type: consentTypes.SET_CURRENT_PAGE,
      pageIdx,
    });
  };
};

export const setCurrentPageRead = pageIdx => {
  return (dispatch, getState) => {
    const pages = getState().consent.pages;

    if (pageIdx === pages.length) {
      return;
    }

    pages[pageIdx].read = true;

    dispatch({
      type: consentTypes.SET_CURRENT_PAGE_READ,
      pageIdx,
      pages,
    });
  };
};

export const getConsentsByDefKey = pageIdx => {
  return async (dispatch, getState) => {
    const pages = getState().consent.pages;
    await fetchConsentsByDefKey(pages[pageIdx].id)
      .then(res => {
        if (res) {
          const state = getState().consent;
          let pages = state.pages;
          pages[pageIdx].consentData = res;
          pages[pageIdx].showGDPCAccepted = res.isGDPC;
          dispatch(getConsentsSuccess(pageIdx, pages));
        } else {
          throw new Error(res.error.message);
        }
      })
      .catch(err => {
        console.error(err);
      });
  };
};

export const submitConsents = () => {
  return async (dispatch, getState) => {
    let acceptedConsents = [];
    const pages = getState().consent.pages;
    for (let i = 0; i < pages.length; i++) {
      acceptedConsents.push(pages[i].id);
    }
    await saveConsentAcceptances(acceptedConsents)
      .then(res => {
        if (res) {
          sessionStorage.removeItem('CN');
          const queryParams = new URLSearchParams(window.location.search);
          if (queryParams.has('redirect')) {
            const redirectUrl = queryParams.get('redirect');
            window.location.replace(redirectUrl.includes('https://') ? redirectUrl : 'https://' + redirectUrl);
          } else {
            window.location.replace(getDashboardURL());
          }
        } else {
          throw new Error(res.error.message);
        }
      })
      .catch(err => {
        console.error(err);
      });
  };
};

export const getConsentsSuccess = (pageIdx, pages) => {
  return dispatch => {
    dispatch({
      type: consentTypes.GET_CONSENT_SUCCESS,
      pageIdx,
      pages,
    });
  };
};

export const toggleConsent = (value, chkType) => {
  return (dispatch, getState) => {
    const state = getState().consent;
    let pages = state.pages;
    pages[state.pageIdx][chkType === CONSENT_TYPES.OTHER ? 'accepted' : 'gdpcAccepted'] = value;
    dispatch({
      type: consentTypes.TOGGLE_CONSENT,
      pages,
    });
  };
};
export const downloadConsent = payload => {
  return async (dispatch, getState) => {
    await downloadSummary(payload)
      .then(res => {
        if (res.success) {
          saveAPIFile(res.consentfileData, res.fileName);
        } else {
          throw new Error(res.error.message);
        }
      })
      .catch(err => {
        console.error(err);
      });
  };
};
